const r = "collab://";
function l(o) {
  return o.startsWith(r);
}
function i(o) {
  if (!l(o))
    throw new Error(`Not a collab URI: ${o}`);
  const t = o.slice(r.length), n = /^org:([^:]+):doc:(.+)$/.exec(t), c = n?.[1], a = n?.[2];
  if (c === void 0 || a === void 0)
    throw new Error(`Invalid collab URI format: ${o}`);
  return {
    orgId: c,
    documentId: a
  };
}
function s(o, t) {
  return `${r}org:${o}:doc:${t}`;
}
export {
  s as b,
  l as i,
  i as p
};
//# sourceMappingURL=collabUri-Do8HqBaW.js.map
